import _property from 'lodash/property'

const appId = _property('appId')
const appType = _property('appType')
const authorizeUrl = _property('authorizeUrl')
const clientId = _property('clientId')
const clientSecret = _property('clientSecret')
const emailPatterns = _property('emailPatterns')
const env = _property('env')
const metadataUrl = _property('metadataUrl')
const platform = _property('platform')
const redirectUri = _property('redirectUri')
const spec = _property('spec')
const tenantId = _property('tenantId')
const tenantName = _property('tenantName')
const url = _property('url')

export default {
  appId,
  appType,
  authorizeUrl,
  clientId,
  clientSecret,
  emailPatterns,
  env,
  metadataUrl,
  platform,
  redirectUri,
  spec,
  tenantId,
  tenantName,
  url
}
